/*
  Exact saving on a Christmas bauble bundle (snippets/bundle-saving.liquid, 15 Oct 2026).
  Reads the Globo "Bauble N design" radio choices. Once every design is picked it
  prices the same baubles bought singly against the bundle, both delivered ($11
  postage under the free post line, free from it, the line comes in the config), and swaps the "Save up to" pill for the
  exact figure. Until then the pill keeps the "up to" figure.
*/
(() => {
  const cfgEl = document.querySelector('[data-bundle-save-config]');
  const detail = document.querySelector('[data-bundle-save-detail]');
  if (!cfgEl || !detail) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const POST = 1100;
  const FREE_FROM = cfg.free || 12000;
  const delivered = (cents) => (cents < FREE_FROM ? cents + POST : cents);
  const money = (cents) => '$' + (cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2));
  const pills = () => document.querySelectorAll('.product__price [data-bundle-save]');
  const upTo = 'Save up to ' + money(cfg.best);
  const pickLine = detail.textContent;

  const update = () => {
    let singles = 0;
    let addons = 0;
    for (let i = 1; i <= cfg.n; i += 1) {
      const pick = document.querySelector('input[type="radio"][name="Bauble ' + i + ' design"]:checked');
      const price = pick && cfg.prices[pick.value];
      if (!price) {
        pills().forEach((p) => { p.textContent = upTo; });
        detail.textContent = pickLine;
        return;
      }
      singles += price;
      addons += Math.round(parseFloat(pick.dataset.addonPrice || '0') * 100);
    }
    const singlesDel = delivered(singles);
    const setDel = delivered(cfg.price + addons);
    const save = singlesDel - setDel;
    if (save <= 0) {
      pills().forEach((p) => { p.textContent = upTo; });
      detail.textContent = pickLine;
      return;
    }
    pills().forEach((p) => { p.textContent = 'You save ' + money(save); });
    detail.textContent = 'Bought singly, your ' + cfg.word + ' cost ' + money(singlesDel) + ' delivered. ' +
      cfg.name + ': ' + money(setDel) + ' delivered.';
  };

  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('input[type="radio"][name$=" design"]')) update();
  });
  document.addEventListener('click', () => setTimeout(update, 0));
  update();
})();
